import React from "react";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { showUrlDokumen } from "stores/Pengajuan/function";
import SplitText from "views/SplitText";
import { uploadSlipTakeOver } from "stores/Pengajuan/function";
import { uploadSkl } from "stores/Pengajuan/function";
import { getAllPengajuan } from "stores/Pengajuan/function";
import Swal from "sweetalert2";
import { showUrlDokumenKunjungan } from "stores";

// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Step6() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;
  const allDetail = pengajuan.detailPengajuan;

  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);
  const [modalUploadTakeOver, setModalUploadTakeOver] = React.useState(false);
  const [slipTakeOver, setSlikTakeOver] = React.useState("");
  const [skl, setSkl] = React.useState("");

  const [loadingSkl, setLoadingSkl] = React.useState(false);
  const [loadingSlipTakeOver, setLoadingSlipTakeOver] = React.useState(false);

  const handleClickPdf = (url) => {
    console.log(url, "URL");
    dispatch({
      type: "PREVIEW_DOKUMEN",
      data: showUrlDokumen(dispatch, { urlImage: url }),
    });
  };

  const handleClickFotoKunjungan = (url) => {
    console.log(url, "URL");
    dispatch({
      type: "PREVIEW_DOKUMEN",
      data: showUrlDokumenKunjungan(dispatch, { urlImage: url }),
    });
  };
  const submitSkl = (e) => {
    if (skl === "") {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "File wajib diisi!",
        showCancelButton: true,
      });
    } else {
      setLoadingSkl(true);
      const formData = new FormData();
      formData.append("skl", skl);
      formData.append("idPengajuan", valDetail.id_pinjaman);
      uploadSkl(formData)
        .then((response) => {
          setLoadingSkl(false);
          if (response.status === 200) {
            // window.location.reload();
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1000,
            });

            // getAllPengajuan(dispatch, {
            //   status: "",
            //   tglAwal: "",
            //   tglAkhir: "",
            //   cari: "",
            //   idWilayah: "",
            // });
            dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
          } else if (response.status === 400) {
            setLoadingSkl(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          } else {
            setLoadingSkl(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.message,
            });
          }
        })
        .catch((error) => {
          console.error("Terjadi kesalahan saat mengirim data profil:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan dalam mengirim data profil.",
          });
        });
    }
  };
  const submitSlipTakeOver = (e) => {
    if (slipTakeOver === "") {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "File wajib diisi!",
        showCancelButton: true,
      });
    } else {
      setLoadingSlipTakeOver(true);
      const formData = new FormData();
      formData.append("slipTakeOver", slipTakeOver);
      formData.append("idPengajuan", valDetail.id_pinjaman);
      uploadSlipTakeOver(formData)
        .then((response) => {
          setLoadingSlipTakeOver(false);
          if (response.status === 200) {
            // window.location.reload();
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1000,
            });

            // getAllPengajuan(dispatch, {
            //   status: "",
            //   tglAwal: "",
            //   tglAkhir: "",
            //   cari: "",
            //   idWilayah: "",
            // });
            dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
          } else if (response.status === 400) {
            setLoadingSlipTakeOver(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.message,
            });
          }
        })
        .catch((error) => {
          console.error("Terjadi kesalahan saat mengirim data profil:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan dalam mengirim data profil.",
          });
        });
    }
  };

  React.useEffect(() => {
    let tmp = [];
    // let newTmpStatusPekerjaan = [];
    // let newTmpStatusMenikah = [];
    Object.entries(valDetail).forEach(([key, value]) => {
      if (
        key != "_id" &&
        key != "id_pinjaman" &&
        key != "createdAt" &&
        key != "updatedAt"
      ) {
        tmp.push({
          key: key,
          url: value,
        });
      }
    });

    // tmp.map((val1) => {
    //   if (allDetail.stepTiga.statusPekerjaan != "Pensiun") {
    //     if (val1.key != "karip") {
    //       newTmpStatusPekerjaan.push(val1);
    //     }
    //   } else if (allDetail.stepTiga.statusPekerjaan === "Pensiun") {
    //     newTmpStatusPekerjaan.push(val1);
    //   }
    // });

    // newTmpStatusPekerjaan.map((val1) => {
    //   if (
    //     allDetail.statusMenikah === "Cerai Hidup" ||
    //     allDetail.statusMenikah === "Cerai Mati"
    //   ) {
    //     if (
    //       val1.key != "buku_nikah" ||
    //       val1.key != "pas_foto_pasangan" ||
    //       val1.key != "ktp_pasangan"
    //     ) {
    //       console.log(val1, "PEPEPEPEPEPEPEPPEPEPEP");
    //       newTmpStatusMenikah.push(val1);
    //     }
    //   } else if (
    //     allDetail.statusMenikah != "Cerai Hidup" ||
    //     allDetail.statusMenikah != "Cerai Mati"
    //   ) {
    //     if (val1.key != "akta_cerai") {
    //       newTmpStatusMenikah.push(val1);
    //     }
    //   }
    // });
    // console.log(tmp, "??????????????????????????????????????????????");
    setListUrlDokumen(tmp);
  }, []);

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  return (
    <>
      {/* <Modal
        size="lg"
        show={modalUploadTakeOver}
        onHide={() => setModalUploadTakeOver(!modalUploadTakeOver)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title
                as="h4"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                Tambah Dokumen Take Over
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                <Form.Group>
                  <label style={{ fontWeight: "bold" }}>SKL</label>
                  <Form.Control
                    onChange={(e) => {
                      setSkl(e.target.files);
                    }}
                    accept=".png, .jpg, .jpeg"
                    placeholder="SKL"
                    type="file"
                  ></Form.Control>
                </Form.Group>
                <Form.Group>
                  <label style={{ fontWeight: "bold" }}>Slip Take Over</label>
                  <Form.Control
                    onChange={(e) => {
                      setSlikTakeOver(e.target.files);
                    }}
                    accept=".png, .jpg, .jpeg"
                    placeholder="Slip Take Over"
                    type="file"
                  ></Form.Control>
                </Form.Group>
              </Form>
            </Card.Body>

            <Card.Footer>
              <Button
                className="btn-fill"
                type="submit"
                // variant="info"
                style={{ backgroundColor: "#00BFFF", border: 0 }}
                // onClick={submitClient}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal> */}

      <Col md="12" style={{ marginTop: 20 }}>
        <Card.Header>
          <Card.Title
            as="h4"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              textAlign: "center",
            }}
          >
            {/* <SplitText
              text="informasi dokumen "
              className="text-9xl font-bold text-center"
              delay={100}
              animationFrom={{
                opacity: 0,
                transform: "translate3d(0,50px,0)",
              }}
              animationTo={{
                opacity: 1,
                transform: "translate3d(0,0,0)",
              }}
              easing="easeOutCubic"
              threshold={0.2}
              rootMargin="-50px"
              onLetterAnimationComplete={handleAnimationComplete}
              fontSize="1.5rem"
            /> */}
            informasi dokumen
            <hr></hr>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Card style={{ border: 0 }}>
            <div style={{ maxHeight: "450px", overflowY: "scroll" }}>
              {/* <Button
                className="btn-wd mr-3"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  backgroundColor: "#013E62",
                  fontWeight: "bold",
                  border: 0,
                }}
                size="md"
                onClick={() => setModalUploadTakeOver(!modalUploadTakeOver)}
              >
                Tambah Dokumen Take Over
              </Button> */}
              <div className="row">
                <div className="col-12">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    PDF
                  </Label>
                  {allDetail.stepEmpat.statusPinjaman === "2" ? (
                    <>
                      <Row>
                        <Col md={"6"}>
                          <Label
                            style={{
                              textTransform: "uppercase",
                              fontSize: 15,
                              fontWeight: "bold",
                              color: "#000000",
                            }}
                          >
                            Slip Take Over
                          </Label>
                        </Col>
                        <Col md={"3"}>
                          {valDetail.slip_takeover ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>Preview Dokumen</Tooltip>}
                            >
                              <Button
                                className="mr-0"
                                disabled={!valDetail.slip_takeover}
                                onClick={() =>
                                  handleClickPdf(valDetail.slip_takeover)
                                }
                                style={{
                                  fontSize: 20,
                                  marginBottom: 15,
                                  textTransform: "capitalize",
                                  marginLeft: 10,
                                  backgroundColor: "#00BFFF",
                                  border: 0,
                                  paddingRight: 40,
                                  paddingLeft: 40,
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-file-pdf"></i>
                              </Button>
                            </OverlayTrigger>
                          ) : (
                            <>
                              <input
                                type="file"
                                accept=".pdf"
                                onChange={(e) =>
                                  setSlikTakeOver(e.target.files[0])
                                }
                                style={{ display: "block", marginBottom: 10 }}
                              />
                              <Button
                                style={{
                                  backgroundColor: "#EC4129",
                                  fontWeight: "bold",
                                  border: 0,
                                }}
                                onClick={submitSlipTakeOver}
                                disabled={loadingSlipTakeOver}
                              >
                                {loadingSlipTakeOver ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "Kirim"
                                )}
                              </Button>
                            </>
                          )}
                        </Col>
                      </Row>
                      <p
                        style={{
                          fontSize: 15,
                          color: valDetail.slip_takeover ? "blue" : "red",
                          fontWeight: valDetail.slip_takeover
                            ? "normal"
                            : "bold",
                        }}
                      >
                        {valDetail.slip_takeover
                          ? valDetail.slip_takeover
                          : "Tidak Ada Dokumen"}
                      </p>

                      <Row>
                        <Col md={"6"}>
                          <Label
                            style={{
                              textTransform: "uppercase",
                              fontSize: 15,
                              fontWeight: "bold",
                              color: "#000000",
                            }}
                          >
                            SKL
                          </Label>
                        </Col>
                        <Col md={"3"}>
                          {valDetail.skl ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>Preview Dokumen</Tooltip>}
                            >
                              <Button
                                className="mr-0"
                                disabled={!valDetail.skl}
                                onClick={() => handleClickPdf(valDetail.skl)}
                                style={{
                                  fontSize: 20,
                                  marginBottom: 15,
                                  textTransform: "capitalize",
                                  marginLeft: 10,
                                  backgroundColor: "#00BFFF",
                                  border: 0,
                                  paddingRight: 40,
                                  paddingLeft: 40,
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-file-pdf"></i>
                              </Button>
                            </OverlayTrigger>
                          ) : (
                            <>
                              <input
                                type="file"
                                accept=".pdf"
                                onChange={(e) => setSkl(e.target.files[0])}
                                style={{ display: "block", marginBottom: 10 }}
                              />
                              <Button
                                style={{
                                  backgroundColor: "#EC4129",
                                  fontWeight: "bold",
                                  border: 0,
                                }}
                                onClick={submitSkl}
                                disabled={loadingSkl}
                              >
                                {loadingSkl ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "Kirim"
                                )}
                              </Button>
                            </>
                          )}
                        </Col>
                      </Row>
                      <p
                        style={{
                          fontSize: 15,
                          color: valDetail.skl ? "blue" : "red",
                          fontWeight: valDetail.skl ? "normal" : "bold",
                        }}
                      >
                        {valDetail.skl ? valDetail.skl : "Tidak Ada Dokumen"}
                      </p>
                    </>
                  ) : null}
                  {/* <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Foto Kunjungan
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!kunjungan.fotoKunjungan}
                          onClick={() => {
                            handleClickPdf(kunjungan.fotoKunjungan);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: kunjungan.fotoKunjungan
                              ? "#00BFFF"
                              : "gray",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                            cursor: kunjungan.fotoKunjungan
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: kunjungan.fotoKunjungan ? "blue" : "red",
                      fontWeight: kunjungan.fotoKunjungan ? "normal" : "bold",
                    }}
                  >
                    {kunjungan.fotoKunjungan
                      ? kunjungan.fotoKunjungan
                      : "Tidak Ada Dokumen"}
                  </p> */}
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Pas Foto Diri
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.pas_foto_diri}
                          onClick={() => {
                            handleClickPdf(valDetail.pas_foto_diri);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.pas_foto_diri
                              ? "#00BFFF"
                              : "gray",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                            cursor: valDetail.pas_foto_diri
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.pas_foto_diri ? "blue" : "red",
                      fontWeight: valDetail.pas_foto_diri ? "normal" : "bold",
                    }}
                  >
                    {valDetail.pas_foto_diri
                      ? valDetail.pas_foto_diri
                      : "Tidak Ada Dokumen"}
                  </p>

                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        KTP Diri
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.ktp_diri}
                          onClick={() => {
                            handleClickPdf(valDetail.ktp_diri);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.ktp_diri
                              ? "#00BFFF"
                              : "gray",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                            cursor: valDetail.ktp_diri
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.ktp_diri ? "blue" : "red",
                      fontWeight: valDetail.ktp_diri ? "normal" : "bold",
                    }}
                  >
                    {valDetail.ktp_diri
                      ? valDetail.ktp_diri
                      : "Tidak Ada Dokumen"}
                  </p>
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Kartu Keluarga
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.kartu_keluarga}
                          onClick={() => {
                            handleClickPdf(valDetail.kartu_keluarga);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.kartu_keluarga
                              ? "#00BFFF"
                              : "gray",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                            cursor: valDetail.kartu_keluarga
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.kartu_keluarga ? "blue" : "red",
                      fontWeight: valDetail.kartu_keluarga ? "normal" : "bold",
                    }}
                  >
                    {valDetail.kartu_keluarga
                      ? valDetail.kartu_keluarga
                      : "Tidak Ada Dokumen"}
                  </p>
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        NPWP
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.npwp}
                          onClick={() => {
                            handleClickPdf(valDetail.npwp);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.npwp
                              ? "#00BFFF"
                              : "gray",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                            cursor: valDetail.npwp ? "pointer" : "not-allowed",
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.npwp ? "blue" : "red",
                      fontWeight: valDetail.npwp ? "normal" : "bold",
                    }}
                  >
                    {valDetail.npwp ? valDetail.npwp : "Tidak Ada Dokumen"}
                  </p>
                  {allDetail.statusMenikah === "Cerai Hidup" ||
                  allDetail.statusMenikah === "Cerai Mati" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Akta Cerai
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            disabled={!valDetail.akta_cerai}
                            onClick={() => {
                              handleClickPdf(valDetail.akta_cerai);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: valDetail.akta_cerai
                                ? "#00BFFF"
                                : "gray",
                              cursor: valDetail.akta_cerai
                                ? "pointer"
                                : "not-allowed",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.statusMenikah === "Cerai Hidup" ||
                  allDetail.statusMenikah === "Cerai Mati" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: valDetail.akta_cerai ? "blue" : "red",
                        fontWeight: valDetail.akta_cerai ? "normal" : "bold",
                      }}
                    >
                      {valDetail.akta_cerai
                        ? valDetail.akta_cerai
                        : "Tidak Ada Dokumen"}
                    </p>
                  ) : null}
                  {allDetail.statusMenikah === "Kawin" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Pas Foto Pasangan
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            disabled={!valDetail.pas_foto_pasangan}
                            onClick={() => {
                              handleClickPdf(valDetail.pas_foto_pasangan);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: valDetail.pas_foto_pasangan
                                ? "#00BFFF"
                                : "gray",
                              cursor: valDetail.pas_foto_pasangan
                                ? "pointer"
                                : "not-allowed",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.statusMenikah === "Kawin" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: valDetail.pas_foto_pasangan ? "blue" : "red",
                        fontWeight: valDetail.pas_foto_pasangan
                          ? "normal"
                          : "bold",
                      }}
                    >
                      {valDetail.pas_foto_pasangan
                        ? valDetail.pas_foto_pasangan
                        : "Tidak Ada Dokumen"}
                    </p>
                  ) : null}
                  {allDetail.statusMenikah === "Kawin" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          KTP Pasangan
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            disabled={!valDetail.ktp_pasangan}
                            onClick={() => {
                              handleClickPdf(valDetail.ktp_pasangan);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: valDetail.ktp_pasangan
                                ? "#00BFFF"
                                : "gray",
                              cursor: valDetail.ktp_pasangan
                                ? "pointer"
                                : "not-allowed",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.statusMenikah === "Kawin" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: valDetail.ktp_pasangan ? "blue" : "red",
                        fontWeight: valDetail.ktp_pasangan ? "normal" : "bold",
                      }}
                    >
                      {valDetail.ktp_pasangan
                        ? valDetail.ktp_pasangan
                        : "Tidak Ada Dokumen"}
                    </p>
                  ) : null}
                  {allDetail.statusMenikah === "Kawin" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Buku Nikah
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            disabled={!valDetail.buku_nikah}
                            onClick={() => {
                              handleClickPdf(valDetail.buku_nikah);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: valDetail.buku_nikah
                                ? "#00BFFF"
                                : "gray",
                              cursor: valDetail.buku_nikah
                                ? "pointer"
                                : "not-allowed",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.statusMenikah === "Kawin" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: valDetail.buku_nikah ? "blue" : "red",
                        fontWeight: valDetail.buku_nikah ? "normal" : "bold",
                      }}
                    >
                      {valDetail.buku_nikah
                        ? valDetail.buku_nikah
                        : "Tidak Ada Dokumen"}
                    </p>
                  ) : null}
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Slip Gaji
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.slip_gaji}
                          onClick={() => {
                            handleClickPdf(valDetail.slip_gaji);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.slip_gaji
                              ? "#00BFFF"
                              : "gray",
                            cursor: valDetail.slip_gaji
                              ? "pointer"
                              : "not-allowed",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.slip_gaji ? "blue" : "red",
                      fontWeight: valDetail.slip_gaji ? "normal" : "bold",
                    }}
                  >
                    {valDetail.slip_gaji
                      ? valDetail.slip_gaji
                      : "Tidak Ada Dokumen"}
                  </p>
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Daftar Gaji
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.daftar_gaji}
                          onClick={() => {
                            handleClickPdf(valDetail.daftar_gaji);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.daftar_gaji
                              ? "#00BFFF"
                              : "gray",
                            cursor: valDetail.daftar_gaji
                              ? "pointer"
                              : "not-allowed",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.daftar_gaji ? "blue" : "red",
                      fontWeight: valDetail.daftar_gaji ? "normal" : "bold",
                    }}
                  >
                    {valDetail.daftar_gaji
                      ? valDetail.daftar_gaji
                      : "Tidak Ada Dokumen"}
                  </p>
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Buku Tabungan
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.buku_tabungan}
                          onClick={() => {
                            handleClickPdf(valDetail.buku_tabungan);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.buku_tabungan
                              ? "#00BFFF"
                              : "gray",
                            cursor: valDetail.buku_tabungan
                              ? "pointer"
                              : "not-allowed",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.buku_tabungan ? "blue" : "red",
                      fontWeight: valDetail.buku_tabungan ? "normal" : "bold",
                    }}
                  >
                    {valDetail.buku_tabungan
                      ? valDetail.buku_tabungan
                      : "Tidak Ada Dokumen"}
                  </p>
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Kartu Pegawai
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.kartu_pegawai}
                          onClick={() => {
                            handleClickPdf(valDetail.kartu_pegawai);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.kartu_pegawai
                              ? "#00BFFF"
                              : "gray",
                            cursor: valDetail.kartu_pegawai
                              ? "pointer"
                              : "not-allowed",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.kartu_pegawai ? "blue" : "red",
                      fontWeight: valDetail.kartu_pegawai ? "normal" : "bold",
                    }}
                  >
                    {valDetail.kartu_pegawai
                      ? valDetail.kartu_pegawai
                      : "Tidak Ada Dokumen"}
                  </p>
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Kartu Taspen
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.kartu_taspen}
                          onClick={() => {
                            handleClickPdf(valDetail.kartu_taspen);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.kartu_taspen
                              ? "#00BFFF"
                              : "gray",
                            cursor: valDetail.kartu_taspen
                              ? "pointer"
                              : "not-allowed",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.kartu_taspen ? "blue" : "red",
                      fontWeight: valDetail.kartu_taspen ? "normal" : "bold",
                    }}
                  >
                    {valDetail.kartu_taspen
                      ? valDetail.kartu_taspen
                      : "Tidak Ada Dokumen"}
                  </p>
                  {allDetail.stepTiga.statusPekerjaan === "Pensiun" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Karip
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            disabled={!valDetail.karip}
                            onClick={() => {
                              handleClickPdf(valDetail.karip);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: valDetail.karip
                                ? "#00BFFF"
                                : "gray",
                              cursor: valDetail.karip
                                ? "pointer"
                                : "not-allowed",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.stepTiga.statusPekerjaan === "Pensiun" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: valDetail.karip ? "blue" : "red",
                        fontWeight: valDetail.karip ? "normal" : "bold",
                      }}
                    >
                      {valDetail.karip ? valDetail.karip : "Tidak Ada Dokumen"}
                    </p>
                  ) : null}
                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        SK / Jaminan
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Preview Dokumen</Tooltip>}
                      >
                        <Button
                          className=" mr-0"
                          // variant="primary"
                          disabled={!valDetail.sk}
                          onClick={() => {
                            handleClickPdf(valDetail.sk);
                          }}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: valDetail.sk ? "#00BFFF" : "gray",
                            cursor: valDetail.sk ? "pointer" : "not-allowed",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 15,
                      color: valDetail.sk ? "blue" : "red",
                      fontWeight: valDetail.sk ? "normal" : "bold",
                    }}
                  >
                    {valDetail.sk ? valDetail.sk : "Tidak Ada Dokumen"}
                  </p>

                  <Row>
                    <Col md={"6"}>
                      <Label
                        style={{
                          textTransform: "uppercase",
                          fontSize: 15,
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        Surat Keterangan Sehat
                      </Label>
                    </Col>
                    <Col md={"3"}>
                      {valDetail.surat_keterangan_sehat ? (
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            disabled={!valDetail.surat_keterangan_sehat}
                            onClick={() => {
                              handleClickPdf(valDetail.surat_keterangan_sehat);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: valDetail.surat_keterangan_sehat
                                ? "#00BFFF"
                                : "gray",
                              cursor: valDetail.surat_keterangan_sehat
                                ? "pointer"
                                : "not-allowed",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      ) : (
                        <Button
                          className=" mr-0"
                          disabled={!valDetail.surat_keterangan_sehat}
                          style={{
                            fontSize: 20,
                            marginBottom: 15,
                            textTransform: "capitalize",
                            marginLeft: 10,
                            backgroundColor: "gray",
                            border: 0,
                            paddingRight: 40,
                            paddingLeft: 40,
                          }}
                        >
                          <i class="fas fa-file-pdf"></i>
                        </Button>
                      )}
                    </Col>
                  </Row>
                  {valDetail.surat_keterangan_sehat ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: valDetail.surat_keterangan_sehat
                          ? "blue"
                          : "red",
                        fontWeight: valDetail.surat_keterangan_sehat
                          ? "normal"
                          : "bold",
                      }}
                    >
                      {valDetail.surat_keterangan_sehat
                        ? valDetail.surat_keterangan_sehat
                        : "Tidak Ada Dokumen"}
                    </p>
                  ) : (
                    <p
                      style={{ fontSize: 15, color: "red", fontWeight: "bold" }}
                    >
                      Tidak Ada Dokumen
                    </p>
                  )}

                  {allDetail.tipeNasabah === "002" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Ijin Usaha
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            onClick={() => {
                              handleClickPdf(valDetail.izin_usaha);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: "blue",
                      }}
                    >
                      {valDetail.izin_usaha}
                    </p>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Rekening Koran Usaha
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            onClick={() => {
                              handleClickPdf(valDetail.rekening_koran_usaha);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: "blue",
                      }}
                    >
                      {valDetail.rekening_koran_usaha}
                    </p>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Nota Usaha
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            onClick={() => {
                              handleClickPdf(valDetail.nota_usaha);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: "blue",
                      }}
                    >
                      {valDetail.nota_usaha}
                    </p>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <Row>
                      <Col md={"6"}>
                        <Label
                          style={{
                            textTransform: "uppercase",
                            fontSize: 15,
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                        >
                          Denah Usaha
                        </Label>
                      </Col>
                      <Col md={"3"}>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Preview Dokumen</Tooltip>}
                        >
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            onClick={() => {
                              handleClickPdf(valDetail.denah_usaha);
                            }}
                            style={{
                              fontSize: 20,
                              marginBottom: 15,
                              textTransform: "capitalize",
                              marginLeft: 10,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingRight: 40,
                              paddingLeft: 40,
                            }}
                          >
                            <i class="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ) : null}
                  {allDetail.tipeNasabah === "002" ? (
                    <p
                      style={{
                        fontSize: 15,
                        color: "blue",
                      }}
                    >
                      {valDetail.denah_usaha}
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
          </Card>
        </Card.Body>
      </Col>
    </>
  );
}
export default Step6;
